export default {
  GET_REGULATIONS_POLICY(state, payload) {
    state.regulationspolicy = payload;
  },
  SELECT_REGULATIONS_POLICY(state, payload) {
    state.selectedregulationspolicy = payload;
  },
};
